var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircleFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 14.6673C11.6825 14.6673 14.6673 11.6825 14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673ZM11.0899 6.92324C11.4153 6.5978 11.4153 6.07017 11.0899 5.74473C10.7645 5.41929 10.2368 5.41929 9.9114 5.74473L7.16732 8.48881L6.08991 7.4114C5.76447 7.08596 5.23683 7.08596 4.9114 7.4114C4.58596 7.73683 4.58596 8.26447 4.9114 8.58991L6.57806 10.2566C6.9035 10.582 7.43114 10.582 7.75657 10.2566L11.0899 6.92324Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleFilled);
export default __webpack_public_path__ + "static/media/icon-check-circle-filled.974a55d467025cced3765450db655f53.svg";
export { ForwardRef as ReactComponent };